"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleSort = exports.TableSorter = void 0;
const _ = __importStar(require("lodash"));
function getSortParams(sortCols) {
    const result = {
        fields: [],
        orders: []
    };
    for (let { colName, sort } of sortCols) {
        if (sort === 1) {
            result.fields.push(colName);
            result.orders.push('asc');
            continue;
        }
        if (sort === -1) {
            result.fields.push(colName);
            result.orders.push('desc');
            continue;
        }
    }
    return result;
}
class TableSorter {
    sortColumns;
    constructor() {
        this.sortColumns = [];
    }
    sortItems(items) {
        const { fields, orders } = getSortParams(this.sortColumns);
        return _.orderBy(items, fields, orders);
    }
    updateSortColumn(colName, sort) {
        const colIndex = _.findIndex(this.sortColumns, { colName });
        if ((colIndex < 0 && sort === -1) || sort === 1) {
            this.sortColumns.push({ colName, sort });
            return;
        }
        if (colIndex > -1 && sort === 0) {
            this.sortColumns.splice(colIndex, 1);
            return;
        }
        if (colIndex > -1 && sort !== undefined) {
            this.sortColumns[colIndex].sort = sort;
        }
    }
}
exports.TableSorter = TableSorter;
function toggleSort(sort) {
    if (sort === 0) {
        return 1;
    }
    if (sort === 1) {
        return -1;
    }
    if (sort === -1) {
        return 0;
    }
}
exports.toggleSort = toggleSort;
//# sourceMappingURL=sort.js.map